import React from "react";
import Logo from "../navbar/Logo";
import SectionParagraph from "../SectionParagraph";
import {useLanguage} from "../../hooks/LanguageContext";

const FooterLogoBox = () => {
	const { direction } = useLanguage(); // Get the direction from LanguageContext

	return (
		<div
			className={`md:w-[263px] w-11/12 flex flex-col items-start gap-[20px] mb-10 ${
				direction === "rtl" ? "text-right" : "text-left"
			}`}
		>
			<Logo />
			<SectionParagraph
				align={"items-start"}
				paragraph={
					direction === "ltr"
						? "Providing reliable, efficient, and safe vehicle transport solutions with a commitment to excellence and customer satisfaction."
						: "تقديم حلول نقل المركبات الموثوقة والفعالة والآمنة مع الالتزام بالتميز وإرضاء العملاء"
				}
			/>
		</div>
	);
};

export default FooterLogoBox;
